<template>
    <div>
        <ApolloQuery :query="require('../graphql/languages.graphql')"
                     :variables="{ named }"
                     v-slot="{ result: { loading, error, data } }">

            <!--show a spinner for when the data is loading-->
            <div v-if="loading"
                 class="loading">
                <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
            </div>

            <!--show a cute gif when there's an error-->
            <div v-else-if="error"
                 class="error">

                <!--a card that has a hover effect-->
                <md-card md-with-hover>
                    <!--actual gif-->
                    <md-card-media-cover md-solid>
                        <md-card-media>
                            <img src="../assets/error.gif" alt="Something is clearly wrong!">
                        </md-card-media>
                    </md-card-media-cover>

                    <!--quote from the gif-->
                    <md-card-area>
                        <md-card-header>
                            <span class="md-subhead">Something is clearly wrong!</span>
                        </md-card-header>
                    </md-card-area>
                </md-card>

            </div>


            <!--actual cards with project information-->
            <div v-else-if="data">
                <div class="chart">
                    <div v-if="isMobile()">
                        <apexchart :width="windowWidth"
                                   :series="computeSeries(data)"
                                   :options="computeConfig(data)"></apexchart>
                    </div>
                    <div v-else>
                        <apexchart height="600"
                                   :width="windowWidth"
                                   :series="computeSeries(data)"
                                   :options="computeConfig(data)"></apexchart>
                    </div>
                </div>
            </div>
        </ApolloQuery>
    </div>
</template>

<script>
    export default {
        name: "Lang",
        data() {
            return {
                values: {},
                windowWidth: window.innerWidth,
            };
        },
        mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth;
            };
        },
        props: {
            named: {
                type: String,
                default: "Sxtanna"
            }
        },
        methods: {
            isMobile() {
                return this.$isMobile();
            },
            computeValues(data) {
                let values = data.user.repositories.nodes.map(e => e.primaryLanguage).filter(it => it != null).reduce((dict, lang) => {
                    dict[lang.name] = {
                        "color": lang.color,
                        "count": dict[lang.name] == null ? 1 : dict[lang.name].count + 1
                    };
                    return dict;
                }, {});

                values["Java"].color = '#f39325';
                values["Kotlin"].color = '#cc5d99';

                this.values = values;
            },
            computeSeries(data) {
                if (Object.keys(this.values).length === 0) {
                    this.computeValues(data);
                }

                return Object.keys(this.values).map(it => this.values[it].count);
            },
            computeConfig(data) {
                if (Object.keys(this.values).length === 0) {
                    this.computeValues(data);
                }

                return {
                    chart: {
                        type: 'donut',
                        animations: {
                            enabled: false,
                        }
                    },
                    labels: Object.keys(this.values),
                    colors: Object.keys(this.values).map(it => this.values[it].color),
                    legend: {
                        show: true,
                        position: 'top',
                        fontSize: '20px',
                        floating: false,
                        labels: {
                            useSeriesColors: false,
                        },
                        itemMargin: {
                            horizontal: 20,
                        }
                    }
                };
            }
        },
    }
</script>

<style scoped>
    .chart {
        display: inline-block;
        align-items: center;
        padding-top: 100px;
    }
</style>